// extracted by mini-css-extract-plugin
module.exports = {"buttons":"style_buttons__OwkYw","button":"style_button__wlRVP"};